import { Box, Typography } from "@mui/material";
import styles from "../../screens/Dashboard/Dashboard.module.css";
import { customTextColor } from "../../utils/const";

const JobPostView = ({
  image,
  position,
  location,
  price,
  hiring,
  btn1,
  btn2,
}) => {
  
  return (
    <Box
      className={styles.recruiter_job_post}
      sx={{ border: "1px solid #f5f5f5",  }}
    >
      <div>
        <img src={image} alt="" />
        <span style={{ color: customTextColor }}>
          <Typography>
            Position :<b> {position}</b>
          </Typography>
          <Typography>
            Rate : <b> {price}</b>
          </Typography>
          <Typography>
            Location:<b> {location}</b>
          </Typography>
          <Typography sx={{ marginBottom: "0 !important" }}>
            Hiring Mode: <b>{hiring}</b>
          </Typography>
        </span>
      </div>
      <div style={{ alignSelf: "flex-end" }}>
        <button
          style={{
            backgroundColor: "#1b89de",
            marginRight: "20px",
            width: "5.7rem",
          }}
        >
          {btn1}
        </button>
        <button style={{ backgroundColor: "#3856a6", }}>{btn2}</button>
      </div>
    </Box>
  );
};

export default JobPostView;
